export const RECERT_TYPES = {
  FULL: 'FULL',
  SHORT: 'SHORT',
  NONE: 'NONE',
};

// Keys of `setup.recertTypes`, in the order the options are offered.
export const RECERT_TYPE_OPTIONS_BY_PROGRAM = {
  LIHTC: [RECERT_TYPES.FULL, RECERT_TYPES.SHORT, RECERT_TYPES.NONE],
  HOME: [RECERT_TYPES.FULL, RECERT_TYPES.SHORT],
  DeferredLoan: [RECERT_TYPES.FULL, RECERT_TYPES.SHORT, RECERT_TYPES.NONE],
  HTF: [RECERT_TYPES.FULL, RECERT_TYPES.SHORT],
  BOND: [RECERT_TYPES.FULL, RECERT_TYPES.SHORT, RECERT_TYPES.NONE],
  NOAH: [RECERT_TYPES.FULL, RECERT_TYPES.SHORT, RECERT_TYPES.NONE],
};

export const RECERT_TYPE_MESSAGE_KEYS = {
  [RECERT_TYPES.FULL]: 'fullRecerts',
  [RECERT_TYPES.SHORT]: 'shortRecerts',
  [RECERT_TYPES.NONE]: 'noRecerts',
};
